module.exports = __webpack_public_path__ + "img/B_logo.e0b14224.png";